import { useLocation, useNavigate } from 'react-router-dom';

import useBankingPath from '#client/hooks/useBankingPath';

import { BANKING_TRANSITION_SEGMENT, BANKING_TRANSITION_STEPS } from './constants';

/**
 * Resolves next/previous steps from the step config so step pages never hardcode paths.
 * Going back from the first step exits to the banking dashboard.
 * @returns {{ goNext: () => void, goBack: () => void, exitToDashboard: () => void, hasPreviousStep: boolean, currentPageName: string | undefined }}
 */
export default function useBankingTransitionStepNavigation() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const bankingPath = useBankingPath();

  const segment = pathname.split('/').filter(Boolean).pop();
  const currentStep = BANKING_TRANSITION_STEPS.find((step) => step.path === segment);
  const transitionBase = `${bankingPath}/${BANKING_TRANSITION_SEGMENT}`;

  const exitToDashboard = () => navigate(`${bankingPath}/dashboard`);

  const goNext = () => {
    const nextPath = currentStep?.next();
    if (nextPath) {
      navigate(`${transitionBase}/${nextPath}`);
    }
  };

  const goBack = () => {
    const previousPath = currentStep?.previous();
    if (previousPath) {
      navigate(`${transitionBase}/${previousPath}`);
    } else {
      exitToDashboard();
    }
  };

  return {
    goNext,
    goBack,
    exitToDashboard,
    hasPreviousStep: currentStep?.previous() != null,
    currentPageName: currentStep?.pageName
  };
}
